import { Component, OnInit } from '@angular/core';
import { EntryPageService } from 'shared/services';
import { UserVisitModel } from 'app/modules/configuration/definition';
import { UserApiService } from 'app/modules/configuration/service';

@Component({
  selector: 'entry-page',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss'],
})
export class ProjectListComponent implements OnInit {

  recentUsers: UserVisitModel[] = [];

  constructor(
    private entryPageService: EntryPageService,
    private userApiService: UserApiService
  ) {

  }

  ngOnInit() {
    if(localStorage.getItem('userId')){
      this.userApiService.getLastLoginUsers().subscribe(users => {
        this.recentUsers = users;
      });
    }
  }

  clickCard() {
    this.entryPageService.sendEntryPageShowChange(false);
  }
}
